import TicketDetailLayout from './TicketDetailLayout';

export default TicketDetailLayout;
